<div class="empty">
  <h3 class="empty__title">{{ title() }}</h3>
  @if (description()) {
    <p class="empty__description">{{ description() }}</p>
  }
  @if (buttonLabel()) {
    <app-button (onClick)="onButtonAction()">{{ buttonLabel() }}</app-button>
  }
</div>
